import { render } from "./AttributeRadarChart.vue?vue&type=template&id=b2017056&scoped=true"
import script from "./AttributeRadarChart.vue?vue&type=script&lang=js"
export * from "./AttributeRadarChart.vue?vue&type=script&lang=js"

import "./AttributeRadarChart.vue?vue&type=style&index=0&id=b2017056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2017056"]])

export default __exports__